







































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { required, minLength } from 'vuelidate/lib/validators';

import ClockIcon from '@/components/Icons/Clock.vue';
import CloseIcon from '@/components/Icons/Close.vue';
import MapIcon from '@/components/Icons/Map.vue';
import PhoneIcon from '@/components/Icons/Phone.vue';

export default Vue.extend({
  name: 'queue-form',
  components: {
    ClockIcon,
    CloseIcon,
    MapIcon,
    PhoneIcon,
  },
  data() {
    return {
      activePage: '',
      submitted: false,
      queueForm: {
        phone: '',
      },
    };
  },
  props: {
    pageType: {
      type: String,
      default: 'hosted',
    },
  },
  validations: {
    queueForm: {
      phone: { required },
    },
  },
  methods: {
    toggleEmail(newState: boolean) {
      (this as any).emailSelected = newState;
    },
    changePage(newPage: number) {
      (this as any).activePage = newPage;
    },
    handleSubmit() {
      // Submit form
    },
  },
  created() {
    if ((this as any).queryParameters.widgetLayout === '1-col-short' || this.pageType === 'webview') {
      (this as any).activePage = 'joinQueue';
    } else {
      (this as any).activePage = 'hosted';
    }
  },
});
